import cn from "classnames";
import Loader from "components/shared/loader";
import { geocoderSourceTypes, geocoderSourceTypesEnum } from "helpers/enums";
import debounce from "lodash/debounce";
import React, { Component } from "react";
import { geocoder, getAddresses, getHereApiLocationById, getMixedAddresses } from "sources/map";

const coordinatesRegex = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;

export default class AddressInput extends Component {
    state = {
        isLoading: false,
        inputAddress: this.props.geopoint?.address || "",
        geopoint: this.props.geopoint,
        suggestions: [],
    };

    constructor(props) {
        super(props);
        this.loadAddresses = debounce(this.loadAddresses, 2000);
    }

    componentDidMount() {
        if (this.props.autofocus) {
            this.addressInput.focus();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { geopoint, isLoading } = nextProps;
        this.setState({ inputAddress: geopoint?.address || "", geopoint, isLoading });
    }

    renderLoader = () => {
        const { isLoading } = this.state;
        if (isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="map__head" />
                </div>
            );
        }
    };

    loadAddresses = (address) => {
        if (address.length) {
            if (coordinatesRegex.test(address)) {
                const [lat, lng] = address.split(",");
                geocoder({ lat: Number(lat.trim()), lng: Number(lng.trim()) }).then((suggestion) =>
                    this.setState({ suggestions: suggestion ? [suggestion] : [], isLoading: false }),
                );
            } else {
                (this.props.source || getMixedAddresses)({ address }).then((suggestions) =>
                    this.setState({ suggestions, isLoading: false }),
                );
            }
        } else {
            this.setState({ suggestions: [], isLoading: false });
        }
    };

    selectAddress = (selectedGeopoint) => {
        this.setState({ isLoading: true });
        if (
            selectedGeopoint.location === null ||
            selectedGeopoint.location.coordinates === null ||
            selectedGeopoint.location.coordinates.length === 0 ||
            !selectedGeopoint.state
        ) {
            switch (selectedGeopoint.geocoderSourceType) {
                case geocoderSourceTypesEnum.Dadata:
                    return getAddresses({ address: selectedGeopoint.address, count: 1 }).then(({ 0: geopoint }) => {
                        this.setState({ suggestions: [], isLoading: false });
                        this.props.onSelectGeopoint(geopoint);
                    });
                case geocoderSourceTypesEnum.Here:
                    return getHereApiLocationById({ locationId: selectedGeopoint.locationId }).then((location) => {
                        this.setState({ suggestions: [], isLoading: false });
                        this.props.onSelectGeopoint({ ...selectedGeopoint, location });
                    });
                case geocoderSourceTypesEnum.Yandex:
                    return geocoder({
                        lat: selectedGeopoint.location.coordinates[1],
                        lng: selectedGeopoint.location.coordinates[0],
                    }).then((address) => {
                        this.setState({ suggestions: [], isLoading: false });
                        this.props.onSelectGeopoint({ ...selectedGeopoint, ...address });
                    });
            }
        } else {
            this.setState({ suggestions: [], isLoading: false });
            this.props.onSelectGeopoint(selectedGeopoint);
        }
    };

    onInputChange = ({ target }) => {
        this.setState({ inputAddress: target.value, isLoading: target.value.length > 0 });
        this.loadAddresses(target.value);
    };

    renderSuggestions = () => {
        const {
            state: { suggestions, inputAddress, isLoading },
            props: { geopoint },
        } = this;
        const selectedAddress = geopoint?.address || "";
        const hasSearchText = inputAddress && inputAddress.length;
        const isSearchingNewAddress = inputAddress !== selectedAddress;

        if (isLoading) {
            return null;
        }
        if (suggestions.length) {
            return this.state.suggestions.map(this.renderSuggestionItem);
        } else {
            return hasSearchText && isSearchingNewAddress ? (
                <div className="map__result-item--empty">
                    Введенный адрес не найден, укажите местоположение, кликнув на объект по карте
                </div>
            ) : null;
        }
    };

    renderAddressToggler = () => {
        return (
            <div className="map__address-toggler">
                <span className={cn("checkbox d-inline-block", { "checkbox--checked": true })} />
                <span className="pl-1">Искать по названию организации</span>
            </div>
        );
    };

    renderSuggestionItem = (geopoint, i) => {
        const { address, geocoderSourceType } = geopoint;
        return (
            <div key={i} className="map__result-item" onClick={this.selectAddress.bind(this, geopoint)}>
                {address}
                {geocoderSourceType && geocoderSourceType !== geocoderSourceTypesEnum.Yandex && (
                    <em className={this.geocoderSourceTypeCname(geocoderSourceType)}>
                        <small>{geocoderSourceTypes.find((item) => item.value === geocoderSourceType).label}</small>
                    </em>
                )}
            </div>
        );
    };

    geocoderSourceTypeCname = (sourceType) =>
        cn("float-right", {
            "text-danger": sourceType === geocoderSourceTypesEnum.Yandex,
            "text-success": sourceType === geocoderSourceTypesEnum.Nominatim,
            "text-primary": sourceType === geocoderSourceTypesEnum.Dadata,
        });

    render() {
        const { inputAddress } = this.state;
        const { resultWrap, inputProps, disabled } = this.props;
        const wrapClasses = cn("map__result-wrap map__result-wrap--shadow", {
            [resultWrap]: !!resultWrap,
        });
        return (
            <>
                <input
                    {...inputProps}
                    disabled={disabled}
                    className={this.props.inputClass || "map__picker-field map__picker-field--desktop"}
                    type="text"
                    value={inputAddress}
                    title={inputAddress}
                    placeholder={this.props.placeholder || "Начните вводить адрес или нажмите на карту"}
                    onChange={this.onInputChange}
                    ref={(input) => (this.addressInput = input)}
                />

                {!this.props.notResponsive && (
                    <textarea
                        {...inputProps}
                        className="map__picker-field map__picker-field--mobile"
                        type="text"
                        value={inputAddress}
                        title={inputAddress}
                        placeholder={this.props.placeholder || "Начните вводить адрес или нажмите на карту"}
                        onChange={this.onInputChange}
                    />
                )}
                <div className={wrapClasses}>
                    {this.renderLoader()}
                    {this.renderSuggestions()}
                </div>
            </>
        );
    }
}
